export default __webpack_public_path__ + "static/media/code_refactoring.bdc30a63.png";